import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { secondaryBtn, FlexContainer, InviteContainer } from "../styles";
import signUpbg from "../img/signup-bg.png";
import InviteText from "../components/InviteText";

const SignUp = () => {


  const promoText = [
    "Save more.",
    "Build you wealth faster.",
    "A much easier approach to everyday banking starts with this first step. Become a member today to access the best intrests rates available**",
  ];

  return (
    <MainSignUp bg={signUpbg}>
      <FlexContainer>
        <InviteText
          header1={promoText[0]}
          header2={promoText[1]}
          para={promoText[2]}
        />

        <FormContainer>
          <MainForm>
            <div className="form-text">
              <h3> Get started with Mazuma</h3>
              <p> One login for all Mazuma products</p>
            </div>

            <div className="form-container">
              <form action="">
                <div className="firstname-div">
                  <label htmlFor="firstname"> First name</label>
                  <input type="text" name="firstname" id="firstname" />
                </div>

                <div className="lastname-div">
                  <label htmlFor="lastname"> Last name</label>
                  <input type="text" name="lastname" id="lastname" />
                </div>

                <div className="email-div">
                  <label htmlFor="email"> Email address</label>
                  <input type="email" name="email" id="email" />
                </div>

                <div className="submit-btn">
                  <GetStarted type="submit"> Get Started </GetStarted>
                </div>
              </form>
            </div>
          </MainForm>
        </FormContainer>
      </FlexContainer>
    </MainSignUp>
  );
};

const MainSignUp = styled(InviteContainer)``;

const GetStarted = styled(secondaryBtn)`
  background: #19456b;
  border: none;
`;

const FormContainer = styled(motion.div)`
  color: black;
  display: flex;
  justify-content: flex-end;
  margin: 3rem 0rem;

  div {
    padding: 1rem 0rem;
  }
`;

const MainForm = styled(motion.div)`
  h2,
  h3,
  p {
    white-space: normal;
    font-family: "Roboto", "Arial";
  }
  background: #f8f1f1;
  min-height: 20rem;
  width: 28rem;
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.4);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .form-text,
  .submit-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    h3 {
      font-size: 1.9rem;

      @media (max-width: 370px) {
        font-size: 1.5rem;
      }
    }

    p {
      padding: 0.5rem 0rem;
      font-size: 0.9rem;

      @media (max-width: 370px) {
        font-size: 0.8rem;
      }
    }
  }

  .firstname-div,
  .lastname-div,
  .email-div,
  .submit-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;

    label {
      font-size: 0.8rem;
      font-weight: bold;
    }

    input {
      border: none;
      font-size: 1rem;
      padding: 0.3rem 1rem;
      border-radius: 0.3rem;
      box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
  }
`;

export default SignUp;
